export default __webpack_public_path__ + "static/media/mechanic-3.e4bd368e.jpg";